export default "__VITE_ASSET__DzzllSfI__"